/*
 * Copyright (c) 2018 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
 *
 *Description:
*/
export default (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$customerBranding = _ref.customerBranding,
      customerBranding = _ref$customerBranding === void 0 ? 'COB' : _ref$customerBranding,
      _ref$business = _ref.business,
      business = _ref$business === void 0 ? false : _ref$business;

  return 'TPB' === customerBranding ? '' : business ? 'Wells Fargo Business Online' : 'Wells Fargo Online';
});